import type { schemaType as strapiHolidaysSchemaType } from '~/modules/api/strapi/vacaciones-landings/detail/schema'
import type { schemaType as strapiHomeSchemaType } from '~/modules/api/strapi/home/schema'
import type { schemaType as StrapiBrandingCampaignSchemaType } from '~/modules/api/strapi/branding-campaign/schema'
import type { propsInterface } from '~/modules/design-system/sections/s-cta-card/s-cta-card.vue'

export const useToSCtaCard = () => {
  const fromStrapiHolidaysDetail = (
    data: strapiHolidaysSchemaType,
  ): propsInterface => {
    const filteredData = {
      image: data.attributes.img?.data?.attributes.url as string,
      imageAlt: t('landings.holidays.banner.alt', {
        name: data.attributes.name,
      }),
      title: t('landings.holidays.banner.title', {
        name: data.attributes.name,
      }),
      link: `/ofertas-casas-rurales/${data.attributes.slug}`,
      buttonText: t('landings.holidays.banner.button-text'),
    }
    return filteredData
  }

  const fromStrapiHome = (
    data: strapiHomeSchemaType,
  ): propsInterface | null => {
    if (data.attributes.image_banner && data.attributes.image_banner.button) {
      const filteredData = {
        image: data.attributes.image_banner.image.data.attributes.url,
        imageAlt: data.attributes.image_banner.title,
        title: data.attributes.image_banner.title,
        subtitle: data.attributes.image_banner.text,
        link: data.attributes.image_banner.button.url as string,
        buttonText: data.attributes.image_banner.button.text as string,
      }
      return filteredData
    } else {
      return null
    }
  }

  const fromStrapiBrandingCampaign = (
    data: StrapiBrandingCampaignSchemaType,
  ): propsInterface | null => {
    if (data.attributes.image_banner && data.attributes.image_banner.button) {
      const filteredData = {
        image: data.attributes.image_banner.image.data.attributes.url,
        imageAlt: data.attributes.image_banner.title,
        title: data.attributes.image_banner.title,
        subtitle: data.attributes.image_banner.text,
        link: data.attributes.image_banner.button.url as string,
        buttonText: data.attributes.image_banner.button.text as string,
      }
      return filteredData
    } else {
      return null
    }
  }

  return {
    fromStrapiHolidaysDetail,
    fromStrapiHome,
    fromStrapiBrandingCampaign,
  }
}
